import React, { useState } from "react";
import { Link } from "react-router-dom";

const categories = ["همه", "فروشگاهی", "شرکتی", "PWA", "پلتفرم"];

const projects = [
  {
    id: 7,
    title: "سایت فروشگاهی منسوجات بافتیکس",
    category: "فروشگاهی",
    image: "./image/baftix1.jpg",
    description: "فروشگاه آنلاین روفرشی کشدار، پرده و روتختی مجهز به خرید اقساطی اسنپ‌پی و دیجی‌پی (Next.js)",
    link: "/project/7",
    featured: false,
  },
  {
    id: 9,
    title: "فروشگاه کتاب‌های زبان آوای دانش",
    category: "فروشگاهی",
    image: "./image/avaaydanesh1.jpg",
    description: "فروشگاه تخصصی کتاب‌های آموزش زبان خارجی و آمادگی آزمون‌های بین‌المللی با فیلترینگ CEFR",
    link: "/project/9",
    featured: false,
  },
  {
    id: 10,
    title: "سامانه هوشمند مدیریت مدارس مدار",
    category: "پلتفرم",
    image: "./image/madaredu1.jpg",
    description: "سامانه ابری چندمستاجره مدیریت مدارس، دفتر کلاسی، حضور و غیاب پیامکی و صدور کارنامه",
    link: "/project/10",
    featured: false,
  },
  {
    id: 2,
    title: "وبسایت کلینیک مشاوره نارون سبز",
    category: "شرکتی",
    image: "./image/narvanweb2.png",
    description: "وبسایت با سیستم رزرو نوبت و پنل ادمین",
    link: "/project/2",
    featured: false,
  },
  {
    id: 3,
    title: "اپ مدیریت کلینیک مشاوره",
    category: "PWA",
    image: "./image/narvan3.png",
    description: "PWA با قابلیت نصب روی تمام دستگاه‌ها",
    link: "/project/3",
    featured: false,
  },
  {
    id: 4,
    title: "پلتفرم رفیتنس",
    category: "پلتفرم",
    image: "./image/rafitnes1.jpg",
    description: "پلتفرم جامع مدیریت تناسب اندام و رفیتنس",
    link: "/project/4",
    featured: false,
  },
  {
    id: 5,
    title: "سایت فروشگاهی کاتن",
    category: "فروشگاهی",
    image: "./image/ka10-1.jpg",
    description: "سایت فروشگاهی پیشرفته با قابلیت مقایسه محصولات",
    link: "/project/5",
    featured: false,
  },
  {
    id: 6,
    title: "سایت فروشگاهی ایران هت",
    category: "فروشگاهی",
    image: "./image/iranhat1.jpg",
    description: "سایت فروشگاهی تخصصی کلاه و محصولات مرتبط",
    link: "/project/6",
    featured: false,
  },
  {
    id: 8,
    title: "سایت فروشگاهی هپی وُرم",
    category: "فروشگاهی",
    image: "./image/happy-worms1.jpg",
    description: "فروشگاه آنلاین میلورم خشک — پرنده، ماهی و لاک‌پشت",
    link: "/project/8",
    featured: false,
  },
];

const Portfolio = () => {
  const [activeCategory, setActiveCategory] = useState("همه");
  const filtered =
    activeCategory === "همه"
      ? projects
      : projects.filter((p) => p.category === activeCategory);

  return (
    <section id="portfolio" className="py-16 sm:py-20 bg-slate-800/50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <p className="text-teal-400 text-sm font-medium text-center mb-2">نمونه‌کارها و پروژه‌ها</p>
        <h2 className="text-2xl sm:text-3xl font-bold text-white text-center mb-4">
          پروژه‌ها و محصولات انجام‌شده
        </h2>
        <p className="text-slate-400 text-center max-w-xl mx-auto mb-10">
          نمونه‌ای از سیستم‌های نرم‌افزاری، پلتفرم‌های ابری و فروشگاه‌های آنلاین طراحی و توسعه یافته در استودیو آلتو
        </p>

        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`relative px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-300 overflow-hidden group ${
                activeCategory === cat
                  ? "bg-teal-600 text-white shadow-md shadow-teal-500/30 scale-105"
                  : "bg-slate-800 text-slate-300 hover:bg-slate-700 border border-slate-600 hover:border-teal-500/50 hover:scale-105"
              }`}
            >
              <span className="relative z-10">{cat}</span>
              {activeCategory === cat && (
                <div className="absolute inset-0 bg-gradient-to-r from-teal-400/0 via-teal-400/50 to-teal-400/0 animate-shimmer" />
              )}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((project) => (
            <Link
              key={project.id}
              to={project.link}
              className={`group block bg-slate-800/80 rounded-xl border overflow-hidden shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-500 relative ${
                project.featured 
                  ? "border-teal-500/60 shadow-teal-500/10 ring-1 ring-teal-500/30" 
                  : "border-slate-700/50 hover:border-teal-500/30 hover:shadow-teal-500/10"
              }`}
              style={{ animationDelay: `${project.id * 0.1}s` }}
            >
              {project.featured && (
                <div className="absolute top-3 left-3 z-20 bg-gradient-to-r from-teal-500 to-emerald-500 text-slate-950 font-bold text-xs px-2.5 py-1 rounded-full shadow-lg flex items-center gap-1">
                  <span className="w-1.5 h-1.5 rounded-full bg-slate-950 animate-pulse"></span>
                  محصول اختصاصی
                </div>
              )}
              <div className="relative aspect-video bg-slate-700 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = "./image/project.png";
                  }}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000 pointer-events-none" />
              </div>
              <div className="p-5 relative">
                <span className="inline-block text-xs font-medium text-teal-400 bg-teal-500/20 px-2 py-1 rounded group-hover:bg-teal-500/30 group-hover:scale-105 transition-all duration-300">
                  {project.category}
                </span>
                <h3 className="font-semibold text-white mt-2 group-hover:text-teal-400 transition-colors">
                  {project.title}
                </h3>
                <p className="text-slate-400 text-sm mt-1 overflow-hidden max-h-12 leading-relaxed">
                  {project.description}
                </p>
                <span className="inline-flex items-center gap-1 text-teal-400 text-sm font-medium mt-3 opacity-0 group-hover:opacity-100 transition-all duration-300 group-hover:translate-x-[-4px]">
                  مشاهده جزییات
                  <svg className="w-4 h-4 group-hover:translate-x-[-2px] transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </span>
                <div className="absolute bottom-0 left-0 w-16 h-16 border-l-2 border-b-2 border-teal-500/0 group-hover:border-teal-500/50 rounded-br-xl transition-colors duration-300" />
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://t.me/altostudio_net"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-teal-400 hover:text-teal-300 font-medium text-sm"
          >
            مشاهده سایر پروژه‌ها در تلگرام
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
